module.exports = __webpack_public_path__ + "img/de-product-classify_img_6.a2f8b696.jpg";